import React, { useEffect, useState } from 'react';
import { 
  FaPlane, 
  FaCompass, 
  FaHeart, 
  FaAward, 
  FaUsers, 
  FaGlobeAmericas,
  FaMapMarkedAlt,
  FaStar
} from 'react-icons/fa';
import '../style.css';

const AboutUs = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="about-us-container">
      {/* Hero Section */}
      <section className={`about-hero ${isVisible ? 'fade-in' : ''}`}>
        <div className="hero-overlay">
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="title-part">About Shree Balaji Travel</span>
              <FaPlane className="plane-icon" />
            </h1>
            <p className="hero-subtitle">Your Trusted Partner in Creating Unforgettable Memories</p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="about-content">
        {/* Welcome Section */}
        <section className={`content-section ${isVisible ? 'slide-up' : ''}`}>
          <div className="section-header">
            <FaCompass className="section-icon compass-icon" />
            <h2>Welcome to Shree Balaji Travel</h2>
          </div>
          <p className="section-text">
            Welcome to Shree Balaji Travel, your trusted travel partner dedicated to helping you explore the world and create unforgettable memories. Whether you're looking to relax on a tropical beach, trek through rugged mountains, immerse yourself in rich cultures, or indulge in luxury experiences, we are here to make your dream vacation come true.
          </p>
          <div className="icon-row">
            <div className="icon-item">
              <div className="icon-circle beach">
                <FaGlobeAmericas />
              </div>
              <p>Beach Getaways</p>
            </div>
            <div className="icon-item">
              <div className="icon-circle mountain">
                <FaMapMarkedAlt />
              </div>
              <p>Mountain Treks</p>
            </div>
            <div className="icon-item">
              <div className="icon-circle culture">
                <FaUsers />
              </div>
              <p>Cultural Immersion</p>
            </div>
            <div className="icon-item">
              <div className="icon-circle luxury">
                <FaStar />
              </div>
              <p>Luxury Experiences</p>
            </div>
          </div>
        </section>

        {/* Mission & History Section */}
        <section className={`content-section mission-section ${isVisible ? 'slide-up-delay' : ''}`}>
          <div className="mission-grid">
            <div className="mission-card">
              <div className="mission-icon">
                <FaHeart />
              </div>
              <h3>Our Passion</h3>
              <p>Founded with a passion for travel and a desire to offer personalized travel experiences, Shree Balaji Travel has become a leader in the industry.</p>
            </div>
            <div className="mission-card">
              <div className="mission-icon">
                <FaAward />
              </div>
              <h3>Our Expertise</h3>
              <p>With years of experience in the travel sector and a team of expert professionals, we specialize in crafting exceptional tours and holiday packages for travelers of all kinds.</p>
            </div>
            <div className="mission-card">
              <div className="mission-icon">
                <FaUsers />
              </div>
              <h3>Our Goal</h3>
              <p>Our goal is to make your journey effortless, enjoyable, and, most importantly, extraordinary.</p>
            </div>
          </div>
        </section>

        {/* Philosophy Section */}
        <section className={`content-section philosophy-section ${isVisible ? 'slide-up-delay-2' : ''}`}>
          <div className="section-header">
            <FaHeart className="section-icon heart-icon" />
            <h2>Our Travel Philosophy</h2>
          </div>
          <div className="philosophy-content">
            <div className="philosophy-text">
              <p>
                We are driven by the belief that each trip should be unique and tailored to the individual's preferences, whether it's a solo adventure, a family vacation, a romantic getaway, or a group tour. Our aim is to be your one-stop destination for all things travel, offering a variety of tours, customized itineraries, and exclusive travel packages that bring your travel dreams to life.
              </p>
              <div className="travel-types">
                <div className="type-tag">Solo Adventures</div>
                <div className="type-tag">Family Vacations</div>
                <div className="type-tag">Romantic Getaways</div>
                <div className="type-tag">Group Tours</div>
              </div>
            </div>
            <div className="philosophy-image">
              <div className="image-placeholder">
                <div className="floating-icons">
                  <FaPlane className="float-icon plane-float" />
                  <FaGlobeAmericas className="float-icon globe-float" />
                  <FaMapMarkedAlt className="float-icon map-float" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className={`cta-section ${isVisible ? 'fade-in-delay' : ''}`}>
          <h2>Ready to Start Your Journey?</h2>
          <p>Let us help you create memories that will last a lifetime.</p>
          <button className="cta-button">Plan Your Trip Today</button>
        </section>
      </main>
    </div>
  );
};

export default AboutUs;